import * as React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import * as s from './RoleTitleAndDescription.scss';
import { Card, FormField, Input, InputArea, Box } from 'wix-style-react';

interface IAppProps extends InjectedTranslateProps {
    title?: string;
    description?: string;
    readOnly: boolean;
    errorMessage?: string;
    titleRef?: any;

    onTitleChange(event: object): void;
    onDescriptionChange(event: object): void;
}

class RoleTitleAndDescription extends React.PureComponent<IAppProps> {
    render() {
        const { t, title, description, readOnly, onTitleChange, onDescriptionChange, errorMessage, titleRef } = this.props;
        return (
            <Card className={s.roleTitleAndDescriptionContainer}>
                <Card.Header
                    title={t(`role.roleDetails${readOnly ? '' : '.edit'}`)}
                    subtitle={t(`role.roleDetailsSubTitle${readOnly ? '' : '.edit'}`)}
                />
                <Card.Divider />
                <Card.Content>
                    <Box className={s.roleTitleAndDescriptionGrid}>
                        <Box direction="vertical" align="left">
                            <Box marginBottom="20px">
                                <FormField label={t('role.title')} labelPlacement="left" required />
                            </Box>
                            <FormField label={t('role.description')} labelPlacement="left" />
                        </Box>
                        <Box direction="vertical" marginLeft="42px" align="left">
                            <Box marginBottom="18px">
                                <Input
                                  ref={titleRef}
                                  readOnly={readOnly}
                                  onChange={onTitleChange}
                                  value={title ?? ''}
                                  autoFocus={!readOnly}
                                  placeholder={t('role.titlePlaceholder')}
                                  dataHook={'roleTitleAndDescription-title-input'}
                                  status={errorMessage ? 'error' : undefined}
                                  statusMessage={t(errorMessage)}
                                  className={s.roleTitleInput}
                                  maxLength={200}
                                />
                            </Box>
                            <InputArea
                              readOnly={readOnly}
                              onChange={onDescriptionChange}
                              value={description}
                              placeholder={!readOnly ? t('role.descriptionPlaceholder') : undefined}
                              dataHook={'roleTitleAndDescription-description-inputArea'}
                              minHeight="84px"
                              maxHeight="84px"
                            />
                        </Box>
                    </Box>
                </Card.Content>
            </Card>
        );
    }
}

export default translate()(RoleTitleAndDescription);
